"use client";

import React from "react";
import { Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-4 w-32 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-4 w-28 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/SecurityPage" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-serif">
            Turvallisuus
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/ContactPage" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-serif">
            Ota yhteyttä
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-secondary transition-colors text-sm font-serif">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="252275" id="footer" className="bg-background text-foreground pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground text-sm max-w-xs font-serif leading-relaxed">Varastomikkeli tarjoaa turvallista ja joustavaa säilytystilaa kaikenlaisiin tarpeisiin</p>
          </div>

          {}
          

          {}
          <div>
            <h3 className="font-default font-bold text-primary mb-6 tracking-tight">Lakitiedot</h3>
            <ul className="space-y-3 mb-8">
              <li data-index={0}>
                <Link to="tietosuojaseloste" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-serif">
                  Tietosuojaseloste
                </Link>
              </li>
              <li data-index={1}>
                <Link to="/kayttoehdot" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-serif">
                  Käyttöehdot
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-4">
              <Link to="#" className="text-muted-foreground hover:text-secondary transition-colors" aria-label="LinkedIn">
                
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-secondary transition-colors" aria-label="X (Twitter)">
                
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-border mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-muted-foreground text-xs leading-relaxed max-w-4xl font-serif">Varastomikkeli on paikallinen säilytyspalvelu. Tarjoamme modernin ratkaisun&nbsp; Mikkelin alueella yksityisille ja yrityksille.</p>
          <p className="text-muted-foreground/60 text-xs shrink-0 font-mono">
            &copy; {new Date().getFullYear()} Varastomikkeli. Kaikki oikeudet pidätetään.
          </p>
        </div>
      </div>
    </section>;
}